import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
import SEO from '../../components/SEO';
import { articles } from '../../data/articles';
import { useLanguage } from '../../i18n/LanguageContext';
import {
  pageStyle, containerStyle, h1Style, introStyle,
  cardStyle, ctaButtonStyle, breadcrumbStyle,
  breadcrumbListStyle, breadcrumbLinkStyle
} from './pageStyles';

export const publishedArticles = articles.filter((a: any) => a.published);

const Knowledge = () => {
  const { t, pick, path } = useLanguage();
  const hasArticles = publishedArticles.length > 0;

  return (
    <div style={pageStyle}>
      <SEO
        title={t('seo.knowledge.title')}
        description={t('seo.knowledge.description')}
        canonicalPath="/knowledge"
        keywords={t('seo.knowledge.keywords')}
        noindex={!hasArticles}
      />
      <Navigation />

      <div style={containerStyle}>
        <nav aria-label="Breadcrumb" style={breadcrumbStyle}>
          <ol style={breadcrumbListStyle}>
            <li><Link to={path('/')} style={breadcrumbLinkStyle}>{t('productPage.breadcrumbHome')}</Link></li>
            <li style={{ color: '#6b7280' }}>/</li>
            <li style={{ color: '#dfa926' }} aria-current="page">{t('knowledge.title')}</li>
          </ol>
        </nav>

        <h1 style={h1Style}>{t('knowledge.title')}</h1>
        <p style={introStyle}>{t('knowledge.intro')}</p>

        {hasArticles && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '1.25rem', marginBottom: '3rem' }}>
            {publishedArticles.map((a: any) => (
              <Link key={a.slug} to={path(`/knowledge/${a.slug}`)} style={cardStyle}>
                <div style={{ padding: '1.5rem' }}>
                  <h2 style={{ color: 'white', fontSize: '1.25rem', fontWeight: 600, margin: '0 0 0.75rem 0' }}>
                    {pick(a, 'title')}
                  </h2>
                  <p style={{ color: '#9ca3af', fontSize: '0.9rem', margin: '0 0 1rem 0', lineHeight: 1.6 }}>
                    {pick(a, 'description')}
                  </p>
                  <span style={{ color: '#dfa926', fontSize: '0.9rem', fontWeight: 600 }}>
                    {t('knowledge.readArticle')} →
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}

        <div style={{ textAlign: 'center' as const, padding: '2rem 0' }}>
          <p style={{ color: '#d1d5db', marginBottom: '1rem' }}>{t('knowledge.ctaTitle')}</p>
          <Link to={path('/contact')} style={ctaButtonStyle}>{t('knowledge.cta')}</Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Knowledge;
